import React from 'react';

/**
 * Casilla MSP de selección: vacía al inicio, muestra «×» al elegir (mejor que solo pintar en amarillo).
 * @param {'cell'|'inline'} variant — cell = ocupa la celda de tabla; inline = cuadro fijo en columna
 */
export default function MspSelectionBox({
  selected = false,
  onToggle,
  readOnly = false,
  ariaLabel = 'Seleccionar',
  variant = 'cell',
}) {
  const className = [
    'msp-sel-box',
    `msp-sel-box--${variant}`,
    selected ? 'msp-sel-box--on' : '',
    readOnly ? 'msp-sel-box--ro' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const mark = selected ? (
    <span className="msp-sel-box__x" aria-hidden>
      ×
    </span>
  ) : null;

  if (readOnly) {
    return (
      <span className={className} aria-hidden={!selected}>
        {mark}
      </span>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={onToggle}
      aria-label={ariaLabel}
      aria-pressed={selected}
    >
      {mark}
    </button>
  );
}
